import type { ReactNode } from 'react';

import styles from './Styles/Default.module.css';

type AnnouncementBarProps = {
  icon?: ReactNode;
  children: ReactNode;
};

export const AnnouncementBar = ({ icon, children }: AnnouncementBarProps) => (
  <div className={styles.bar} role="status" aria-live="polite" data-announcement-bar="">
    {icon && (
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
    )}
    <div className={styles.content}>{children}</div>
  </div>
);
